import { useState } from "react";
import { FormikHelpers } from "formik";
import { useSnackbar } from "notistack";

import { IAuthService } from "../../../../modules/user/models/IAuthService";
import { useIocContext } from "../../../../contexts/ioc/IocContext";
import { Types } from "../../../../ioc/types";
import { useQuery } from "../../../../hooks/Query";
import { QueryTypesNewPassword } from "../../../../config/routes";
import { getSnackbar } from "../../../../utils/Snackbars";
import AppError from "../../../../utils/appError";
import { FormikValuesChangePassword } from "../../form/interfaceValues";

// Lógica única do reset de senha via link do e-mail, extraída de ChangePassword.
// email e verification_code vêm da query string; ambos obrigatórios (AppError quando faltam);
// changePassword({ email, password: confirmPass, confirmation_code }); sucesso → estado de
// sucesso + snackbar; AppError mantém a variante; erro genérico vira mensagem padrão.
// Consumida pela Default e pela Branded.
export function useChangePasswordSubmit() {
  const query = useQuery<QueryTypesNewPassword>();
  const { enqueueSnackbar } = useSnackbar();

  const iocContext = useIocContext();
  const authService = iocContext.serviceContainer.get<IAuthService>(
    Types.User.IAuthService
  );

  const [successChangePassword, setSuccessChangePassword] = useState(false);

  const handleSubmit = async (
    values: FormikValuesChangePassword,
    actions: FormikHelpers<FormikValuesChangePassword>
  ) => {
    try {
      const emailParameter = query.get("email") as string;
      if (!emailParameter) {
        throw new AppError(
          "O email precisa ser informado no parametro da url",
          "error"
        );
      }

      const codeParameter = query.get("verification_code") as string;
      if (!codeParameter) {
        throw new AppError(
          "O codigo de confirmacao precisa ser informado no parametro da url",
          "error"
        );
      }

      await authService.changePassword({
        email: emailParameter,
        password: values.confirmPass,
        confirmation_code: codeParameter,
      });

      actions.resetForm();

      setSuccessChangePassword(true);

      enqueueSnackbar(
        getSnackbar({
          message: "Senha atualizada com sucesso",
          variant: "success",
        })
      );
    } catch (error) {
      setSuccessChangePassword(false);

      if (error instanceof AppError) {
        return enqueueSnackbar(
          getSnackbar({ message: error.message, variant: error.variant })
        );
      } else {
        return enqueueSnackbar(
          getSnackbar({
            message: `Não foi possível enviar o email, tente novamente.`,
            variant: "error",
          })
        );
      }
    }
  };

  return { handleSubmit, successChangePassword };
}
